export default theme => ({
  container: () => ({
    position: 'relative',
    width: 'auto',
    height: '100vh',
  }),
  overlay: () => ({
    position: 'absolute',
    left: 0,
    top: 50,
    right: 0,
    bottom: 0,
    zIndex: 2,
    backgroundColor: theme.palette.loaderBackground.default,
  }),
  loader: () => ({
    position: 'absolute',
    transform: 'translateY(-50%)',
    webkitTransform: 'translateY(-50%)',
    msTransform: 'translateY(-50%)',
    top: '50%',
    left: 0,
    right: 0,
    textAlign: 'center',
  }),
});
